import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import Moment from 'moment'
import {BrowserRouter} from 'react-router-dom';
import {unregister} from './registerServiceWorker';
import getFilms from './api-helpers/getFilms'
import ScrollToTop from './components/snippets/ScrollToTop'

Moment.locale('uk')


unregister()

function ErrorGeneral() {
  return <div className="error">Error</div>
}

function Loading() {
  return <div className="loading">Loading</div>
}

class ApplicationWithState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      error: null,
      data: null,
      is404: false,
    };
  }

  componentDidMount() {
    if (window.initialData) {
      const {data, soon} = window.initialData;
      this.setState({isLoaded: true, data, soon});
      return
    }
    if (window.is404) {
      this.setState({isLoaded: true, is404: true});
      return
    }
    Promise.all([getFilms('client'), getFilms('client', true)])
      .then(([data, soon]) => {
        this.setState({isLoaded: true, error: false, data, soon});
      }, error => {
        this.setState({isLoaded: true, error});
      });
  }

  render() {
    const {isLoaded, data, soon} = this.state;
    if (isLoaded) {
      return (
        <BrowserRouter>
          <ScrollToTop>
            <App {...data} soon={soon} is404={this.state.is404}/>
          </ScrollToTop>
        </BrowserRouter>
      );
    }
    return null
  }
}

ReactDOM.hydrate(<ApplicationWithState/>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js